import { render, staticRenderFns } from "./TelegramForm.vue?vue&type=template&id=f712ea9a&scoped=true"
import script from "./TelegramForm.vue?vue&type=script&lang=js"
export * from "./TelegramForm.vue?vue&type=script&lang=js"
import style0 from "./TelegramForm.vue?vue&type=style&index=0&id=f712ea9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f712ea9a",
  null
  
)

export default component.exports